import React from "react";
import { Button, Navbar } from "reactstrap";
import { Link, useHistory, useLocation } from "react-router-dom";
import DataExtractLogo from "components/Images/DataExtractLogo";
import { useContext } from "react";
import { AppContext } from "components/AppContext";
import brokenGraphic from "components/Images/error-500.svg";

const ErrorMessage = ({ message }) => {
  const { signOut } = useContext(AppContext);
  const { pathname } = useLocation();
  const history = useHistory();

  const selectedAccountDetails = JSON.parse(
    localStorage.getItem("accountDeatils")
  );

  return (
    <>
      <div className="landingPage">
        <Navbar fixed="top">
          {pathname === "/errordisplay" ? (
            <div to="/" className="mr-auto navbar-brand">
              <DataExtractLogo />
            </div>
          ) : (
            <Link to="/" className="mr-auto navbar-brand">
              <DataExtractLogo />
            </Link>
          )}
        </Navbar>
        <div className="landingPage__body" style={{ flexDirection: "column" }}>
          <img className="error__image" src={brokenGraphic} alt=" " />
          <h4 style={{ margin: 20 }}>Oops...</h4>
          <h4>{message}</h4>
          {pathname === "/errordisplay" ? (
            <Button
              color="primary"
              onClick={() => {
                signOut();
              }}
            >
              Go Back
            </Button>
          ) : (
            <Button
              color="primary"
              onClick={() => {
                if (selectedAccountDetails?.id) {
                  history.push(`/app/account/${selectedAccountDetails?.id}`);
                } else {
                  history.push("/");
                }
              }}
            >
              Go Back
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default ErrorMessage;
